import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'
// @ts-ignore
import { IconButton, Plus as PlusIcon, Tooltip } from '@netbasequid/core'
import { sendTypedMessage } from 'utils/iframeUtil'
import { useBooleanVariationFromFeatureFlag } from 'hooks/useBooleanVariationFromFeatureFlag'
import { EDIT_REDIRECT_FEATURE_FLAG } from 'app/featureFlags'
import { useExitNewDashboardMode } from '../hooks'

const ClickableText = styled.span<{ $theme: SystemTheme }>`
  cursor: pointer;
  color: ${({ $theme }) => $theme.interaction.primary.default};
  text-decoration: underline;
  &:hover {
    color: ${({ $theme }) => $theme.interaction.primary.hover};
  }
  &:active {
    color: ${({ $theme }) => $theme.interaction.primary.pressed};
  }
`

const CreateButton = () => {
  const mode = useDisplayTheme()
  const theme = useSysTheme()
  const exitNewDashboardMode = useExitNewDashboardMode()
  const hasExperimentEditFeature = useBooleanVariationFromFeatureFlag(EDIT_REDIRECT_FEATURE_FLAG)

  return (
    <Tooltip
      mode={mode}
      content={
        <span>
          <Trans
            i18nKey="dashboardViewTooltip.create"
            components={{
              CustomLink: <ClickableText $theme={theme} onClick={exitNewDashboardMode} />
            }}
          />
        </span>
      }
      followCursor={false}
      placement="bottom"
      enabled={!hasExperimentEditFeature}
      offset={[0, 2]}>
      <IconButton
        mode={mode}
        color="primary"
        variant="contained"
        disabled={!hasExperimentEditFeature}
        onClick={() => hasExperimentEditFeature && sendTypedMessage('goToCreateDashboard')}
        // for tooltip to work on disabled button
        style={{ pointerEvents: 'all' }}>
        <PlusIcon mode={mode} />
      </IconButton>
    </Tooltip>
  )
}

export default CreateButton
